import axios from 'axios';
import defaultUser from '../utils/default-user';
import { auth } from '../firebase';

const baseUrl = process.env.REACT_APP_API_URL;
let authToken = '';

// export async function signIn(email: string, password: string) {
export async function signIn(data: any) {
  let userData = {
    isOk: false,
    message: "Authentication failed",
    data: undefined
  };

  authToken = data?.accessToken;

  localStorage.setItem('authToken', data?.accessToken);

  try {
    await axios.post(`${baseUrl}/api/User/loginUser`, { email: data?.email }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      })
      .then(response => {
        if(response.data.data !== -1) { 
          userData = {
            isOk: true,
            message: "Authentication successful",
            data: response.data.data
          };
          getUser();
        }
      });
    return userData;
  }
  catch {
    return userData;
  }
}

export async function getUser() {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return {
        isOk: false,
        message: "No user found"
      };
    }

    const token = await currentUser.getIdToken();

    const response = await axios.get(`${baseUrl}/api/User/userByEmail`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return {
      isOk: true,
      message: "Authentication successful",
      data: response.data.data
    };
  } catch (error) {
    console.error('Error fetching user:', error);
    return {
      isOk: false,
      message: "Authentication failed"
    };
  }
}

export async function createAccount(email: string, password: string) {
  try {
    // Send request
    console.log(email, password);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to create account"
    };
  }
}

export async function changePassword(email: string, recoveryCode?: string) {
  try {
    // Send request
    console.log(email, recoveryCode);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to change password"
    }
  }
}

export async function resetPassword(email: string) {
  try {
    // Send request
    console.log(email);

    return {
      isOk: true
    };
  }
  catch {
    return {
      isOk: false,
      message: "Failed to reset password"
    };
  }
}
